import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { generateForm } from '../../form/Form';
import { get, Map } from 'immutable';
import { fetchWebApi, createWebApi, updateWebApi, fetchSecurityPolicyDefinitions, fetchSpace, fetchTree, createTree, updateTree } from '../../../apis';
export var WEB_API_METHODS = ['GET', 'POST', 'PUT', 'DELETE'];
var securityEndpoints = {
  webApiExecution: {
    endpoint: 'Execution',
    label: 'WebAPI Execution',
    types: ['Space', 'Kapp']
  }
};

var dataSources = function dataSources(_ref) {
  var slug = _ref.slug,
      kappSlug = _ref.kappSlug;
  return {
    webApi: {
      fn: fetchWebApi,
      params: slug && [{
        slug: slug,
        kappSlug: kappSlug,
        include: 'details,securityPolicies'
      }],
      transform: function transform(result) {
        return result.webApi;
      }
    },
    securityPolicyDefinitions: {
      fn: fetchSecurityPolicyDefinitions,
      params: kappSlug ? [{
        kappSlug: kappSlug
      }] : [],
      transform: function transform(result) {
        return result.securityPolicyDefinitions;
      }
    },
    sourceName: {
      fn: fetchSpace,
      params: [{
        include: 'platformComponents'
      }],
      transform: function transform(result) {
        return result.space.platformComponents.task.config.platformSourceName;
      }
    },
    sourceGroup: {
      fn: function fn() {
        return kappSlug ? "WebApis > ".concat(kappSlug) : 'WebApis';
      },
      params: []
    },
    tree: {
      fn: fetchTree,
      params: function params(_ref2) {
        var sourceName = _ref2.sourceName,
            sourceGroup = _ref2.sourceGroup,
            webApi = _ref2.webApi;
        return webApi && sourceName && [{
          sourceName: sourceName,
          sourceGroup: sourceGroup,
          name: webApi.get('slug')
        }];
      },
      transform: function transform(result) {
        return result.error && result.error.notFound ? {} : result.tree;
      }
    }
  };
};

var handleSubmit = function handleSubmit(_ref3) {
  var slug = _ref3.slug,
      kappSlug = _ref3.kappSlug;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, bindings) {
      var sourceGroup, sourceName, tree, _yield, webApi, error, _yield$createTree, createTreeError, _yield$updateTree, updateTreeError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sourceGroup = bindings.sourceGroup, sourceName = bindings.sourceName, tree = bindings.tree;
              _context.next = 3;
              return (slug ? updateWebApi : createWebApi)({
                kappSlug: kappSlug,
                slug: slug,
                webApi: values.toJS(),
                include: 'securityPolicies'
              });

            case 3:
              _yield = _context.sent;
              webApi = _yield.webApi;
              error = _yield.error;

              if (!error) {
                _context.next = 8;
                break;
              }

              throw error.statusCode === 400 && error.message || 'There was an error saving the WebAPI';

            case 8:
              if (slug) {
                _context.next = 17;
                break;
              }

              _context.next = 11;
              return createTree({
                tree: {
                  sourceGroup: sourceGroup,
                  sourceName: sourceName,
                  name: values.get('slug')
                }
              });

            case 11:
              _yield$createTree = _context.sent;
              createTreeError = _yield$createTree.error;

              if (!createTreeError) {
                _context.next = 15;
                break;
              }

              throw createTreeError.statusCode === 400 && createTreeError.message || 'There was an error creating the WebAPI tree';

            case 15:
              _context.next = 24;
              break;

            case 17:
              if (!(!tree.isEmpty() && slug !== values.get('slug'))) {
                _context.next = 24;
                break;
              }

              _context.next = 20;
              return updateTree({
                sourceName: sourceName,
                sourceGroup: sourceGroup,
                name: slug,
                tree: {
                  sourceGroup: sourceGroup,
                  sourceName: sourceName,
                  name: values.get('slug')
                }
              });

            case 20:
              _yield$updateTree = _context.sent;
              updateTreeError = _yield$updateTree.error;

              if (!updateTreeError) {
                _context.next = 24;
                break;
              }

              throw updateTreeError.statusCode === 400 && updateTreeError.message || 'There was an error updating the WebAPI tree';

            case 24:
              return _context.abrupt("return", webApi);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var fields = function fields(_ref5) {
  var slug = _ref5.slug;
  return function (_ref6) {
    var tree = _ref6.tree,
        webApi = _ref6.webApi;
    return (!slug || webApi && tree) && [{
      name: 'slug',
      label: 'Slug',
      type: 'text',
      required: true,
      initialValue: get(webApi, 'slug') || ''
    }, {
      name: 'method',
      label: 'Method',
      type: 'select',
      required: true,
      options: WEB_API_METHODS.map(function (el) {
        return {
          value: el,
          label: el
        };
      }),
      initialValue: get(webApi, 'method') || ''
    }].concat(_toConsumableArray(Object.entries(securityEndpoints).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          endpointFieldName = _ref8[0],
          endpoint = _ref8[1];

      return {
        name: endpointFieldName,
        label: endpoint.label,
        type: 'select',
        options: function options(_ref9) {
          var securityPolicyDefinitions = _ref9.securityPolicyDefinitions;
          return securityPolicyDefinitions ? securityPolicyDefinitions.filter(function (definition) {
            return endpoint.types.includes(definition.get('type'));
          }).map(function (definition) {
            return Map({
              value: definition.get('name'),
              label: definition.get('name')
            });
          }) : [];
        },
        initialValue: webApi ? webApi.get('securityPolicies').find(function (pol) {
          return pol.get('endpoint') === endpoint.endpoint;
        }, null, Map({})).get('name', '') : '',
        "transient": true
      };
    })), [{
      name: 'securityPolicies',
      label: 'Security Policies',
      type: null,
      visible: false,
      serialize: function serialize(_ref10) {
        var values = _ref10.values;
        return Object.entries(securityEndpoints).map(function (_ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              endpointFieldName = _ref12[0],
              policy = _ref12[1];

          return {
            endpoint: policy.endpoint,
            name: values.get(endpointFieldName)
          };
        }).filter(function (endpoint) {
          return endpoint.name !== '';
        });
      },
      initialValue: get(webApi, 'securityPolicies')
    }]);
  };
};

export var WebApiForm = generateForm({
  formOptions: ['slug', 'kappSlug'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
WebApiForm.displayName = 'WebApiForm';